import { genericSelector } from 'utils/redux-utils'

import { PROFILE_REDUCER_NAME } from '../consts'
import { AGREEMENTS_REDUCER_NAME } from './consts'

export const { data: agreementsDataSelector } = genericSelector([
  PROFILE_REDUCER_NAME,
  AGREEMENTS_REDUCER_NAME,
])
